export const DEFAULT_ROWS_PER_PAGE = 25;
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];
